import { useState } from "react";
import SC from "./style";
import AddressBook from "views/ProjectHome/AddressBook";

const PrimaryContacts = () => {
  const [count, setCount] = useState(0);

  return (
    <div style={{ marginBottom: "24px" }}>
      <SC.HeaderContainer>
        <SC.HeaderStyle>Primary Contacts</SC.HeaderStyle>
        <SC.CountStyle>{count}</SC.CountStyle>
      </SC.HeaderContainer>
      <SC.CardContainerStyle>
        <AddressBook hide={true} setCount={setCount} />
      </SC.CardContainerStyle>
    </div>
  );
};

export default PrimaryContacts;
